module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_unknown-360f821cf47c34eb457eb236034679c0.png";